<template>
  <div class="cmp-tabs">


    <!-- BEPSOKE GOOL: Changed length to 0 -->
    <ul v-if="computedTabs.length > 0" class="tabs">
      <!-- END BESPOKE GOOL -->
      <li v-for="tab in computedTabs" :key="tab.id" :class="{'active': tab.active }" class="tab">
        <a @click="switchTab(tab.id)">{{ tab.description }}</a>
      </li>
    </ul>

    <div class="tab-panels">
      <div v-for="tab in computedTabs" :key="tab.id" :class="{'active': tab.active }" class="cmp-slot tab-slot tab-panel">
        <transition name="fadein">
        <div class="tab-panel-inner" v-if="tab.active">
          <slot :name="[tab.id]"></slot>
        </div>
        </transition>
      </div>
      
    <slot :name="'readmore'"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: { type: Array, required: false }
  },
  data() {
    return {
      hoverTimeout: null
    };
  },
  computed: {
    computedTabs () {
      const tabs = this.tabs.filter(filter => filter.visible);
      if (tabs.length) { 
        tabs.forEach((x, index) => x.active = index == 0)
       };
      return tabs;
    }
  },
  methods: {
    startHover() {
      if (!this.isHoveredOn) {
        this.hoverTimeout = setTimeout(() => {
          this.$emit('hoveredOnTabs');
        }, 1500);
      }
    },
    endHover() {
      clearTimeout(this.hoverTimeout);
    },
    switchTab (tabId) {
      this.computedTabs.forEach(tab => {
        this.endHover();
        this.$emit('hoveredOnTabs');
        if (tab.id === tabId) {
          tab.active = true;
        } else {
          tab.active = false;
        }
      });
    }
  }
}
</script>

<style>

</style>
